
export const selectPermissions = (state) =>
  state?.auth?.auth?.details?.permissions || [];

export const selectRole = (state) => state?.auth?.auth?.details?.role || null;

const toList = (required) =>
  required == null ? [] : Array.isArray(required) ? required : [required];

export const hasPermission = (permissions = [], required) =>
  !required || permissions.includes(required);

export const hasAnyPermission = (permissions = [], required = []) => {
  const list = toList(required);
  return list.length === 0 || list.some((p) => permissions.includes(p));
};

export const hasAllPermissions = (permissions = [], required = []) => {
  const list = toList(required);
  return list.length === 0 || list.every((p) => permissions.includes(p));
};

